import React from 'react';
import PropTypes from 'prop-types';
import './styles.scss';
import { Tooltip } from '@components/Tippy';
import { APP_TOOLTIPS, getTooltip } from '../../../../../src/texts/tooltips';
import Input from '@components/Input';
import { APP_TEXTS } from '@texts';

const FigurePlates = props => (
  <React.Fragment>
  <ul className="inline-list">
    {props.buttons.map(item => (
    <Tooltip  key={item.id}  content={getTooltip(item.tooltip)}>
      <li key={item.id}>
        <button className={`btn btn-light ${item.id === props.activeBtn && 'ImageButton--active'}`} onClick={() => {
          let resetCustomCoords = true;
          if(item.withInput) {
            props.onClick({ count: parseInt(props.figureValue), id: item.id });
            if (item.id === props.activeBtn)
              resetCustomCoords = false; // do not reset if user clicks again on the same custom button
          } else {
            props.onClick(item);
          }
          if (resetCustomCoords && props.specifyCoordinates)
            props.setCustomCoordinates(false);
        }}>
          <span className={item.icon} />
        </button>       
      </li>
      </Tooltip>
   ))}

    {props.buttons.find((btn) => btn.id === props.activeBtn && btn.withInput) && (
      <Tooltip content={APP_TOOLTIPS.TOOLTIP_INPUT_FIXINGS.Content}> 
    
        <div className="input-group mt-2 w-25 float-right">
          <div className="input-group-prepend">
            <span className="input-group-text">{APP_TEXTS.LABEL_BUTTONS_CUSTOM_N.Content}</span>
          </div>
          <Input
            className="w-25"
            id="N"
            type="number"
            placeholder="N"
            minValue={1}
            maxValue={25}
            value={props.figureValue}
            disabled={props.specifyCoordinates}
            onUpdate={value => { props.onClick({ count: parseInt(value), id: props.activeBtn }); }}
          />
        </div>
      </Tooltip>
    )}
  </ul>
  </React.Fragment>
);

FigurePlates.propTypes = {
  buttons: PropTypes.array.isRequired,
  // options: PropTypes.object.isRequired,
  figureValue: PropTypes.number,
  activeBtn: PropTypes.string,
  specifyCoordinates: PropTypes.bool
};

export default FigurePlates;



// WEBPACK FOOTER //
// ./src/views/Application/types/GeneralCalculation/FigurePlates.js